// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list[data-v-3580a578] {\n  display: contents;\n  flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n.list > div[data-v-3580a578] {\n  display: contents;\n}", ""]);
// Exports
module.exports = exports;
